import React from 'react';

import { InvisibleChildren, SkeletonLoaderWrapper } from './styles';

interface SkeletonLoaderProps {
    isLoading?: boolean | null;
    children?: React.ReactElement | null;
    style?: React.CSSProperties;
}

export const SkeletonLoader = ({ isLoading, children, style, ...other }: SkeletonLoaderProps) => {
    if (!isLoading && children) {
        return children;
    }

    return (
        <SkeletonLoaderWrapper style={style} {...other}>
            <InvisibleChildren>{children}</InvisibleChildren>
        </SkeletonLoaderWrapper>
    );
};
